import PortalAppService from "../../../application/platform/portal-app-service";
import { useNewsDetailDispatch } from "./news-detail-context";
import { ACTION_TYPES } from "./news-detail-reducer";

export const useNewsDetailController = () => {
    const dispatch = useNewsDetailDispatch();

    const loadNewsDetail = async (id: number) => {
        try {
            const newsDetail = await PortalAppService.getNewsDetail(id);
            dispatch({ type: ACTION_TYPES.SET_NEWS_DETAIL, payload: newsDetail });
        } catch (error) {
            console.error('Error loading news detail:', error);
        }
    };

    return { loadNewsDetail };
};
